import React from "react";
import { ReactSVG } from "react-svg";

import { PreviewBrowserProps } from "./types";
import { getSiteInfo } from "@/sites";

import "./styles.scss";

export const PreviewBrowser = ({ type }: PreviewBrowserProps) => {
  const { domainName } = getSiteInfo(process.env.NEXT_PUBLIC_DOMAIN);
  return (
    <>
      <ReactSVG
        src={`/images/phone-previews/browser-mobile.svg`}
        className="preview-frame-browser"
      />
      {type !== "url" && <div className="browser-url">{`www.${domainName}`}</div>}
    </>
  );
};
